module.exports = __webpack_public_path__ + "img/cake-2.22a24bff.svg";